import * as React from 'react';
import { connect } from 'react-redux';
import { Field } from '@progress/kendo-react-form';
import { provideLocalizationService, registerForLocalization } from '@progress/kendo-react-intl';
import { FilterForm, WrapLayout, TextBox, DropDown } from '../../../ui';
import { filterClaims, clearClaimsFilter } from '../actions/claim-review-list-page-actions';

const CLAIM_STATUSES = [
  { id: 'PendingReview', name: 'PendingReview' },
  { id: 'Approved', name: 'Approved' },
  { id: 'Rejected', name: 'Rejected' }
];

class ClaimReviewListFilter extends React.PureComponent {
  constructor() {
    super();
    this.statuses = [];
  }

  render() {
    const {
      filter,
      filterClaims: onFilter,
      clearClaimsFilter: onClear
    } = this.props;
    const localizationService = provideLocalizationService(this);
    const statuses = CLAIM_STATUSES.map(s => ({
      id: s.id,
      name: localizationService.toLanguageString('generalCompetencyClaimReview.status' + s.id)
    }));
    return (
      <FilterForm
        initialValues={filter}
        onSubmit={onFilter}
        onClear={onClear}
        localizationService={localizationService}
        title={localizationService.toLanguageString('grid.filterTitle')}
        uniqueKey={JSON.stringify(filter)}
        render={() => (
          <WrapLayout>
            <Field
              name='keyword'
              width='340px'
              component={TextBox}
              label={localizationService.toLanguageString('custom.search')}
            />
            <Field
              name='status'
              width='340px'
              component={DropDown}
              label={localizationService.toLanguageString('generalCompetencyClaimReview.status')}
              textField='name'
              dataItemKey='id'
              data={statuses}
            />
          </WrapLayout>
        )}
      />
    );
  }
}

const mapStateToProps = state => ({
  filter: state.claimReviewListPage.filter
});

const mapDispatchToProps = dispatch => ({
  filterClaims: (payload) => dispatch(filterClaims(payload)),
  clearClaimsFilter: () => dispatch(clearClaimsFilter())
});

registerForLocalization(ClaimReviewListFilter);

export default connect(mapStateToProps, mapDispatchToProps)(ClaimReviewListFilter);
